module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_3016.62eb2cb0.png";